module.exports = __webpack_public_path__ + "static/media/logo187.9fa0ec9e.png";